import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function userService() {
  const api = useApi()

  function getUser(id) {
    return api.query(`${URLS.users}${id}/`)
  }

  // function patchComentario(id, data) {
  //   return api.mutation(`${URLS.comentarios}${id}/`, 'PATCH', data)
  // }

  return {
    getUser,
    ...api,
  }
}
